{
  "primevue": {
    "accept": "Yes",
    "reject": "No",
    "choose": "Choose",
    "upload": "Upload",
    "cancel": "Cancel",
    "dayNames": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "firstDayOfWeek": 0,
    "dayNamesShort": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "dayNamesMin": [
      "Su",
      "Mo",
      "Tu",
      "We",
      "Th",
      "Fr",
      "Sa"
    ],
    "monthNames": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "today": "Today",
    "clear": "Clear",
    "dateFormat": "yy-mm-dd",
    "weekHeader": "Wk",
    "aria": {
      "trueLabel": "True",
      "falseLabel": "False",
      "nullLabel": "Not Selected",
      "star": "1 star",
      "stars": "{star} stars",
      "selectAll": "All items selected",
      "unselectAll": "All items unselected",
      "close": "Close",
      "previous": "Previous",
      "next": "Next",
      "navigation": "Navigation",
      "scrollTop": "Scroll Top",
      "moveTop": "Move Top",
      "moveUp": "Move Up",
      "moveDown": "Move Down",
      "moveBottom": "Move Bottom",
      "moveToTarget": "Move to Target",
      "moveToSource": "Move to Source",
      "moveAllToTarget": "Move All to Target",
      "moveAllToSource": "Move All to Source",
      "pageLabel": "Page {page}",
      "firstPageLabel": "First Page",
      "lastPageLabel": "Last Page",
      "nextPageLabel": "Next Page",
      "prevPageLabel": "Previous Page",
      "rowsPerPageLabel": "Rows per page",
      "jumpToPageDropdownLabel": "Jump to Page Dropdown",
      "jumpToPageInputLabel": "Jump to Page Input",
      "selectRow": "Row Selected",
      "unselectRow": "Row Unselected",
      "expandRow": "Row Expanded",
      "collapseRow": "Row Collapsed",
      "showFilterMenu": "Show Filter Menu",
      "hideFilterMenu": "Hide Filter Menu",
      "filterOperator": "Filter Operator",
      "filterConstraint": "Filter Constraint",
      "editRow": "Row Edit",
      "saveEdit": "Save Edit",
      "cancelEdit": "Cancel Edit",
      "listView": "List View",
      "gridView": "Grid View",
      "slide": "Slide",
      "slideNumber": "{slideNumber}",
      "zoomImage": "Zoom Image",
      "zoomIn": "Zoom In",
      "zoomOut": "Zoom Out",
      "rotateRight": "Rotate Right",
      "rotateLeft": "Rotate Left",
      "selectLabel": "Select",
      "unselectLabel": "Unselect",
      "removeLabel": "Remove",
      "selectColor": "Select a color",
      "passwordShow": "Show Password",
      "passwordHide": "Hide Password"
    }
  }
}